import { TranslationMap } from '@trimble-gcs/i18n-types';

export function classificationTranslations() {
  return {
    noData: {
      text: $localize`:@@singleSelectedClassification.noData:No classification data.`,
      desc: 'Message shown when there is no classification data for the selected point cloud.',
    },
    addClassification: {
      tooltip: {
        text: $localize`:@@singleSelectedClassification.addClassification.tooltip:Add Classification`,
        desc: 'Tooltip for the add classification button.',
      },
    },
    editClassification: {
      tooltip: {
        text: $localize`:@@singleSelectedClassification.editClassification.tooltip:Edit Classification`,
        desc: 'Tooltip for the edit classification button.',
      },
    },
    unallocatedClassifications: {
      '=1': {
        text: $localize`:@@singleSelectedClassification.unallocatedClassifications.one:1 other class with zero value not shown`,
        desc: 'Message shown when there is 1 unallocated classification with zero value not displayed.',
      },
      other: {
        text: $localize`:@@singleSelectedClassification.unallocatedClassifications.other:{count} other classes with zero value not shown`,
        desc: 'Message shown when there are multiple unallocated classifications with zero value not displayed.',
      },
    },
  } satisfies TranslationMap;
}
